import Vue from "vue";
const drag = Vue.directive("drag", {
  bind: function (el) { },
  //inserted表示一个元素，插入到DOM中会执行inserted函数，只触发一次
  inserted: function (el) {
    el.onmousedown = function (e) {
      var disx = e.pageX - el.offsetLeft;
      var disy = e.pageY - el.offsetTop;
      document.onmousemove = function (e) {
        let left = e.pageX - disx <= 0 ? 0 : e.pageX - disx;
        left =
          left >= document.body.clientWidth - el.offsetWidth
            ? document.body.clientWidth - el.offsetWidth
            : left;
        el.style.left = left - 1 + "px";
        el.style.top = 20 + "px";
      };
      document.onmouseup = function () {
        document.onmousemove = document.onmouseup = null;
      };
    };
  },
  //当VNode更新的时候会执行updated，可以触发多次
  updated: function (el) { },
});
const dragInter = Vue.directive("dragInter", {
  bind: function (el) { },
  //inserted表示一个元素，插入到DOM中会执行inserted函数，只触发一次
  inserted: function (el, data) {
    var el = document.getElementById(data.value.split('_')[0]);
    el.onmousedown = function (e) {
      console.log(e)
      if (e && e.target && e.target._prevClass &&  e.target._prevClass.includes(data.value.split('_')[1])) {
        var disx = e.pageX - el.offsetLeft;
        var disy = e.pageY - el.offsetTop;
        document.onmousemove = function (e) {
          let left = e.pageX - disx <= 0 ? 0 : e.pageX - disx;
          left =
            left >= document.body.clientWidth - el.offsetWidth
              ? document.body.clientWidth - el.offsetWidth
              : left;
          let top = e.pageY - disy <= 0 ? 0 : e.pageY - disy;
          top =
            top >= document.body.clientHeight - el.offsetHeight
              ? document.body.clientHeight - el.offsetHeight
              : top;
          el.style.left = left - 1 + "px";
          el.style.top = top + "px";
        };
        document.onmouseup = function () {
          document.onmousemove = document.onmouseup = null;
        };
      }
    };
  },
  //当VNode更新的时候会执行updated，可以触发多次
  updated: function (el) { },
});
const inputclose = Vue.directive("inputclose", {
  inserted: function (el, binding) {
    var inputEle = el.getElementsByClassName("ivu-input")[0];
    var imgUrl = "static/images/input_close.png";
    var imgEle = document.createElement("img");
    imgEle.src = imgUrl;
    imgEle.style.position = "absolute";
    imgEle.style.right = "8px";
    imgEle.style.width = "19px";
    imgEle.style.top = "27%";
    imgEle.style.cursor = "pointer";
    imgEle.style.display = "none";
    // imgEle.style.backgroundColor = '#fff';
    el.appendChild(imgEle);
    inputEle.addEventListener(
      "keyup",
      () => {
        if (!inputEle.value) {
          imgEle.style.display = "none";
        } else {
          imgEle.style.display = "inline-block";
        }
      },
      false
    );
    imgEle.onclick = () => {
      inputEle.value = "";
      if (binding.value && binding.value.changeData) {
        binding.value.changeData();
      }
      if (binding.value && binding.value.changeUserName) {
        binding.value.changeUserName();
      }
      if (binding.value && binding.value.changeRoomid) {
        binding.value.changeRoomid();
      }
      imgEle.style.display = "none";
    };
  },
  unbind: function () {
    //解绑
    console.log("5 - unbinding");
  },
});
export default {
  drag,
  inputclose,
  dragInter,
};
